import Paper from "@mui/material/Paper";
import { Button, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import BodyText from "../../../components/BodyText";
import SubTitle from "../../../components/SubTitle";
import appLogoImg from "../../../assets/cosmo-app-logo.png";

const buttonHref = /Android/i.test(navigator.userAgent)
  ? "https://play.google.com/store/apps/details?id=com.cosmo.missioncontrol&hl=en_US&gl=US"
  : "https://apps.apple.com/us/app/cosmo-mission-control/id1580600845";

const MobileAppInfoCard = () => (
  <Paper
    sx={{
      width: "100%",
      borderTopLeftRadius: 30,
      borderTopRightRadius: 30,
      display: { xs: "flex", md: "none" },
      flexDirection: "column",
      alignItems: "center",
      px: "2%",
      py: "15px",
    }}
    elevation={3}
  >
    <BodyText>Next Step</BodyText>
    <SubTitle>Download the App</SubTitle>
    <ListItem sx={{ pl: 0, width: "80%" }}>
      <ListItemAvatar sx={{ mr: "11px", display: "flex", pt: "2px" }}>
        <img src={appLogoImg} alt="Cosmo App Logo" />
      </ListItemAvatar>
      <ListItemText
        primary="COSMO: Mission Control"
        secondary="The app for parental control"
        primaryTypographyProps={{ sx: { fontWeight: 600 } }}
      />
    </ListItem>
    <Button variant="contained" sx={{ my: "4%", py: "3%", px: "10%", boxShadow: "none" }} href={buttonHref}>
      Download the COSMO App
    </Button>
    <BodyText>
      Or
      {" "}
      <Link to="/" reloadDocument>
        activate another device
      </Link>
    </BodyText>
  </Paper>
);

export default MobileAppInfoCard;
